/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _defineProperty = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.mapStateToProps = exports.mapDispatchToProps = exports.name = exports.FeatureSelector = void 0;

var react_1 = __importStar(require("react"));

var smoothscroll_polyfill_1 = __importDefault(require("smoothscroll-polyfill"));

var brightsmith_core_1 = require("brightsmith-core");

var brightsmith_core_2 = require("brightsmith-core");

var brightsmith_redux_1 = require("brightsmith-redux");

var DataUtils_1 = __importDefault(require("./utils/DataUtils"));

if (!brightsmith_core_2.Util.isReactNative()) {
  smoothscroll_polyfill_1.default.polyfill();
}

var BrightsmithDb = brightsmith_core_1.Db.BrightsmithDb;
var name = 'FeatureSelector';
exports.name = name;
var defaultOpts = {
  scrollToAdjustment: 115
};

var FeatureSelector = function FeatureSelector(components) {
  var Frame = components.Frame,
      Category = components.Category,
      styles = components.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.categoryRefs = {};

      if (props.Category) {
        Category = props.Category;
      }

      _this.renderByCategory = _this.renderByCategory.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var _this$props = this.props,
            currentCategoryId = _this$props.currentCategoryId,
            shouldScrollToCategory = _this$props.shouldScrollToCategory;

        if ((prevProps === null || prevProps === void 0 ? void 0 : prevProps.currentCategoryId) !== currentCategoryId && shouldScrollToCategory) {
          var ref = this.categoryRefs[currentCategoryId];
          var parentElement = ref.current.parentElement;

          if (parentElement) {
            ref.current.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }
      }
    }, {
      key: "renderByCategory",
      value: function renderByCategory(categoryIds) {
        var _this2 = this;

        return categoryIds.map(function (categoryId) {
          _this2.categoryRefs[categoryId] = react_1.createRef();
          return react_1.default.createElement(Category, {
            key: categoryId,
            categoryId: categoryId,
            forwardedRef: _this2.categoryRefs[categoryId]
          });
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var _this$props2 = this.props,
            after = _this$props2.after,
            before = _this$props2.before,
            CategoryHeader = _this$props2.CategoryHeader,
            categoryIds = _this$props2.categoryIds,
            classes = _this$props2.classes,
            currentCategoryId = _this$props2.currentCategoryId,
            LeadsForm = _this$props2.LeadsForm,
            left = _this$props2.left,
            _this$props2$opts = _this$props2.opts,
            opts = _this$props2$opts === void 0 ? defaultOpts : _this$props2$opts,
            setCurrentCategoryId = _this$props2.setCurrentCategoryId;
        var scrollToAdjustment = opts === null || opts === void 0 ? void 0 : opts.scrollToAdjustment;
        return react_1.default.createElement(Frame, {
          className: ['Feature-Selector__container', classes === null || classes === void 0 ? void 0 : classes.container, _defineProperty({}, classes === null || classes === void 0 ? void 0 : classes.floatLeft, left === true)],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, CategoryHeader, react_1.default.createElement(Frame, {
          className: ['Feature-Selector__inner', classes === null || classes === void 0 ? void 0 : classes.inner],
          onScroll: function onScroll(e) {
            var scrollTop = e.target.scrollTop;
            Object.keys(_this3.categoryRefs).reverse().some(function (categoryId) {
              var ref = _this3.categoryRefs[categoryId];
              var offsetTop = ref.current.offsetTop;

              if (scrollTop > offsetTop - scrollToAdjustment) {
                if (currentCategoryId !== categoryId) {
                  setCurrentCategoryId(categoryId, false);
                }

                return true;
              }

              return false;
            });
          },
          style: styles === null || styles === void 0 ? void 0 : styles.inner
        }, react_1.default.createElement(Frame, {
          className: ['Feature-Selector__categories', classes === null || classes === void 0 ? void 0 : classes.categories, {}],
          style: styles === null || styles === void 0 ? void 0 : styles.categories
        }, categoryIds && this.renderByCategory(categoryIds)), LeadsForm), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.FeatureSelector = FeatureSelector;
var mapDispatchToProps = {
  setCurrentCategoryId: brightsmith_redux_1.Actions.Ui.setCurrentCategory
};
exports.mapDispatchToProps = mapDispatchToProps;

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var api = state.api,
      ui = state.ui;
  var db = new BrightsmithDb(api);
  var categories = DataUtils_1.default.sort(db.getCategories());
  var categoryIds = categories.filter(function (c) {
    return !!!c.parentCategory && c.active !== false;
  }).map(function (c) {
    return c.id;
  });
  var currentCategoryId = ui.currentCategoryId,
      shouldScrollToCategory = ui.shouldScrollToCategory;
  return {
    categoryIds: categoryIds,
    currentCategoryId: currentCategoryId,
    shouldScrollToCategory: shouldScrollToCategory
  };
};

exports.mapStateToProps = mapStateToProps;

var style = function style(theme) {
  var _Object$assign;

  var _a, _b, _c, _d, _e, _f;

  return {
    categories: Object.assign({
      paddingBottom: 35
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.FeatureSelector) === null || _a === void 0 ? void 0 : _a.categories),
    container: Object.assign((_Object$assign = {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: 350,
      order: 2,
      zIndex: 2
    }, _defineProperty(_Object$assign, "@media (max-width: ".concat((_b = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _b === void 0 ? void 0 : _b.mobile, "px)"), {
      maxWidth: 'none',
      minWidth: 'none'
    }), _defineProperty(_Object$assign, '@mobile', {
      maxWidth: '100%'
    }), _Object$assign), (_c = theme === null || theme === void 0 ? void 0 : theme.FeatureSelector) === null || _c === void 0 ? void 0 : _c.container),
    floatLeft: {
      order: 1
    },
    hideOnMobile: _defineProperty({}, "@media (max-width: ".concat((_d = theme === null || theme === void 0 ? void 0 : theme.breakpoints) === null || _d === void 0 ? void 0 : _d.mobile, "px)"), {
      display: 'none'
    }),
    inner: Object.assign({
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      overflow: 'hidden'
    }, (_e = theme === null || theme === void 0 ? void 0 : theme.FeatureSelector) === null || _e === void 0 ? void 0 : _e.inner),
    scroll: Object.assign({
      display: 'flex',
      height: '100%'
    }, (_f = theme === null || theme === void 0 ? void 0 : theme.FeatureSelector) === null || _f === void 0 ? void 0 : _f.scroll)
  };
};

exports.style = style;